import { render, staticRenderFns } from "./comment-ameliorer-son-site-internet.vue?vue&type=template&id=5c8e0c4a&"
import script from "./comment-ameliorer-son-site-internet.vue?vue&type=script&lang=js&"
export * from "./comment-ameliorer-son-site-internet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports